export default "__VITE_ASSET__C9fqF0rr__"